import { DeleteListSortPropertyJoinProps } from '../../utility/types';
import { api } from '../configs/axiosConfigs';

export const deleteListSortPropertyJoin = async ({ listSortId, propertyId }: DeleteListSortPropertyJoinProps) => {
  return await api.delete(`list-sorts/${listSortId}/property/${propertyId}`);
};
